
import { defineComponent, inject } from 'vue';
export default defineComponent({
    name: 'Child',
    setup() {
        const color = inject('color');
        return {
            color,
        }
    }
});
